import ParseUtils from "../utils/parse-utils.ts";

export default class User {
  public readonly id: string;
  public readonly name: string;

  constructor(id: string, name: string) {
    this.id = id;
    this.name = name;
  }

  public static fromPayload(payload: Record<string, unknown>): User {
    const id: string = ParseUtils.parseString(payload, "id");
    const name: string = ParseUtils.parseString(payload, "name");
    return new User(id, name);
  }
}
